var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2227_19174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9103 6.64545L12.9835 5.68579C12.9119 5.61195 12.8778 5.50724 12.8923 5.40551L13.0784 4.08483C13.1548 3.5433 12.7925 3.04542 12.2543 2.95122L10.9405 2.72082C10.8391 2.70309 10.7498 2.63812 10.7019 2.54687L10.0777 1.3693C9.82132 0.88554 9.23516 0.695181 8.74352 0.936064L7.54593 1.52222C7.45338 1.56752 7.34309 1.56752 7.25054 1.52222L6.05295 0.936064C5.56099 0.695154 4.97546 0.885514 4.71881 1.3693L4.09458 2.54687C4.046 2.63942 3.9587 2.70245 3.85598 2.72082L2.54253 2.95122C2.00394 3.04507 1.64194 3.5433 1.71841 4.08448L1.90417 5.40548C1.91861 5.50854 1.8858 5.61092 1.81295 5.68576L0.886106 6.64542C0.506715 7.03795 0.506715 7.65363 0.886106 8.04617L1.81295 9.00582C1.8845 9.07966 1.91861 9.18437 1.90417 9.28611L1.71809 10.6068C1.64162 11.1483 2.00394 11.6462 2.54218 11.7404L3.85595 11.9708C3.95737 11.9885 4.04663 12.0535 4.09455 12.1447L4.71878 13.3223C4.97544 13.8061 5.56128 13.9964 6.05292 13.7555L7.25051 13.1694C7.34306 13.1241 7.45335 13.1241 7.5459 13.1694L8.74349 13.7555C8.88758 13.8261 9.03952 13.8596 9.18918 13.8596C9.5502 13.8596 9.89646 13.6643 10.0776 13.3223L10.7018 12.1448C10.7504 12.0522 10.8377 11.9892 10.9404 11.9708L12.2539 11.7404C12.7925 11.6466 13.1545 11.1483 13.078 10.6072L12.8922 9.28616C12.8778 9.1831 12.9106 9.08072 12.9834 9.00588L13.9103 8.04622C14.2898 7.65366 14.2898 7.03798 13.9103 6.64545ZM13.4269 7.57948L12.5001 8.53847C12.2825 8.76361 12.183 9.07015 12.2267 9.37999L12.4124 10.7007C12.438 10.8812 12.3173 11.0472 12.1381 11.0788L10.824 11.3091C10.5155 11.3633 10.2545 11.5533 10.1078 11.83L9.48361 13.0073C9.39828 13.1687 9.20333 13.2324 9.03891 13.152L7.84132 12.5655C7.70281 12.4979 7.55052 12.4638 7.39826 12.4638C7.246 12.4638 7.09369 12.4979 6.9552 12.5658L5.75761 13.1517C5.59383 13.2324 5.39824 13.1687 5.31291 13.0073L4.68868 11.8297C4.54197 11.5527 4.28072 11.363 3.9719 11.3091L2.65844 11.0784C2.47926 11.0469 2.35846 10.8812 2.38373 10.7007L2.56982 9.37999C2.61347 9.07015 2.51401 8.76364 2.29676 8.53882L1.3696 7.57948C1.24325 7.44819 1.24325 7.24342 1.3696 7.11213L2.29644 6.15314C2.51404 5.928 2.61347 5.62146 2.56982 5.31163L2.38405 3.99095C2.35846 3.81044 2.47923 3.64437 2.65841 3.61286L3.97253 3.38246C4.28104 3.3283 4.54197 3.13829 4.68865 2.86162L5.31288 1.68436C5.39821 1.52289 5.59383 1.45988 5.75759 1.53961L6.95518 2.12612C7.23217 2.26133 7.5643 2.26165 7.84132 2.1258L9.03891 1.53998C9.20301 1.45925 9.39828 1.52291 9.48361 1.68439L10.1078 2.86196C10.2546 3.13895 10.5158 3.32867 10.8246 3.38249L12.1381 3.61321C12.3173 3.64472 12.4381 3.81044 12.4128 3.99098L12.2267 5.31165C12.1831 5.62149 12.2825 5.928 12.4998 6.15282L13.4269 7.11213C13.5533 7.24342 13.5533 7.44822 13.4269 7.57948Z",
    fill: "url(#paint0_linear_2227_19174)",
    stroke: "url(#paint1_linear_2227_19174)",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65154 5.09273C9.52025 4.96144 9.30759 4.96144 9.1763 5.09273L5.14339 9.12564C5.0121 9.25693 5.0121 9.46959 5.14339 9.60088C5.20902 9.66651 5.29501 9.69935 5.381 9.69935C5.467 9.69935 5.55299 9.66654 5.61862 9.60088L9.65154 5.56796C9.7828 5.43668 9.7828 5.22402 9.65154 5.09273Z",
    fill: "url(#paint2_linear_2227_19174)",
    stroke: "url(#paint3_linear_2227_19174)",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.06298 5.66626C7.06298 4.92452 6.45975 4.32129 5.71802 4.32129C4.97628 4.32129 4.37305 4.92452 4.37305 5.66626C4.37305 6.408 4.97628 7.01123 5.71802 7.01123C6.45975 7.01123 7.06298 6.408 7.06298 5.66626ZM5.04523 5.66626C5.04523 5.29539 5.34717 4.99344 5.71804 4.99344C6.08891 4.99344 6.39086 5.29539 6.39086 5.66626C6.39086 6.03713 6.08891 6.33907 5.71804 6.33907C5.34715 6.33907 5.04523 6.03713 5.04523 5.66626Z",
    fill: "url(#paint4_linear_2227_19174)",
    stroke: "url(#paint5_linear_2227_19174)",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.07739 7.68152C8.33565 7.68152 7.73242 8.28475 7.73242 9.02649C7.73242 9.76823 8.33565 10.3715 9.07739 10.3715C9.81913 10.3715 10.4224 9.76823 10.4224 9.02649C10.4224 8.28475 9.81913 7.68152 9.07739 7.68152ZM9.07739 9.69928C8.70652 9.69928 8.40457 9.39733 8.40457 9.02646C8.40457 8.65559 8.70652 8.35364 9.07739 8.35364C9.44826 8.35364 9.75021 8.65559 9.75021 9.02646C9.75021 9.39733 9.44826 9.69928 9.07739 9.69928Z",
    fill: "url(#paint6_linear_2227_19174)",
    stroke: "url(#paint7_linear_2227_19174)",
    strokeWidth: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2227_19174",
    x1: 11.8553,
    y1: -5.48281,
    x2: 1.55559,
    y2: -3.82761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D354FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA30FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA30FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2227_19174",
    x1: 11.8553,
    y1: -5.48281,
    x2: 1.55559,
    y2: -3.82761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D354FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA30FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA30FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2227_19174",
    x1: 8.94017,
    y1: 2.71365,
    x2: 5.36781,
    y2: 3.26385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D354FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA30FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA30FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2227_19174",
    x1: 8.94017,
    y1: 2.71365,
    x2: 5.36781,
    y2: 3.26385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D354FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA30FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA30FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2227_19174",
    x1: 6.6,
    y1: 3.01744,
    x2: 4.55765,
    y2: 3.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D354FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA30FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA30FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2227_19174",
    x1: 6.6,
    y1: 3.01744,
    x2: 4.55765,
    y2: 3.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D354FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA30FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA30FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2227_19174",
    x1: 9.95938,
    y1: 6.37767,
    x2: 7.91702,
    y2: 6.69223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D354FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA30FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA30FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2227_19174",
    x1: 9.95938,
    y1: 6.37767,
    x2: 7.91702,
    y2: 6.69223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D354FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA30FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA30FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2227_19174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.398438 0.345825)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.596482861ec2f777a696eecb7f7cc369.svg";
export { ForwardRef as ReactComponent };